<div class="top_container">
    <div class="title">{{ "timeline.qrcode.title" | translate}}</div>
    <img class="quit_cross" src="assets/images/quit_cross.svg" (click)="closePopin()">
</div>
<div class="body">
    <div class="label">{{"timeline.qrcode.labelLong" | translate}}</div>
    <div >
        <img class="qrcode" [src]="data.qrcode">
    </div>
    <div class="label">{{"timeline.qrcode.transition" | translate}}</div>
    <span class="code">{{ "timeline.qrcode.code" | translate}} {{data.confidentialCode}}</span>
</div>